import Trend from './Trend';
export default Trend;     